module.exports = __webpack_public_path__ + "static/softball-clubhouse-makeover-9413d8b9c79bf2509fbb186c75454a29.jpg";